export default __webpack_public_path__ + "static/media/arrow-down.36baf08d.svg";